import { render } from "./ProgramsDataTable.vue?vue&type=template&id=0cb9aaf0"
import script from "./ProgramsDataTable.vue?vue&type=script&lang=js"
export * from "./ProgramsDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__